import React, { useMemo } from "react";
import { Tooltip } from "@ubnt/ui-components/Tooltip";
import { MoreHorizontalIcon } from "@ubnt/icons";
import { IProductTagProps } from "./InstallationAddonTags.type";
import * as S from "./InstallationAddonTags.styles";

const DEFAULT_VISIBLE_COUNT = 3;

export const VideoCardTags = ({
  tags,
  title,
  isDarker,
  visibleTagsCount = DEFAULT_VISIBLE_COUNT,
}: Readonly<IProductTagProps>) => {
  const mappedTags = useMemo(() => {
    if (tags.length <= visibleTagsCount) {
      return { main: tags, additional: [] };
    }

    return {
      main: tags.slice(0, visibleTagsCount),
      additional: tags.slice(visibleTagsCount),
    };
  }, [tags, visibleTagsCount]);

  // TODO: Remove when all installation essentials updated to label, value pairs
  const additionalMappedAndJoinedTags = useMemo(() => {
    const tags = mappedTags.additional as Array<{
      label: string;
      id: string;
    }>;

    return tags.every(({ label }) => !!label)
      ? tags.map(({ label }) => label).join(", ")
      : tags.join(", ");
  }, [mappedTags.additional]);

  return (
    <S.TagWrapper>
      {mappedTags.main.map((tag, index) => (
        <S.Tag key={`${title}-${tag?.id}-${index}`} $isDarker={isDarker}>
          {tag?.label ?? (tag as unknown as string)}
        </S.Tag>
      ))}

      {!!mappedTags.additional.length && (
        <S.Tag $isDarker={isDarker}>
          <Tooltip
            description={additionalMappedAndJoinedTags}
            width="max-content"
          >
            <S.IconWrapper>
              <MoreHorizontalIcon
                color="black"
                size={12}
                style={{ display: "block" }}
              />
            </S.IconWrapper>
          </Tooltip>
        </S.Tag>
      )}
    </S.TagWrapper>
  );
};
